import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import moment from "moment";
import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import { faEye, faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import commonStyles from "../../../lib/common/common.module.css";
import { update, listFAQs, removeFAQ, getAllCMSCountry, deleteCountryInsta, deleteBanner } from "../api";
import { CMSSchema } from "../validations";
import styles from "../styles/cms.module.css";
import { CMS_TYPE, LOCAL_CONSTANTS } from "../../../lib/constants";
import { CMSTypes } from "../../../interfaces";
import { CONSTANTS } from "../../../lib/constants/messages";
import { ActionButton, DropDownMenu, Pagination, Popup } from "../../../ui";
import { IMAGES } from "../../../assets/images";
import { useParams } from "react-router-dom";
import { listCountries } from "../../plans/api";
import CreateUpdateBanner from "../../../ui/Popup/createUpdateBanner";
import ImagePreviewModal from "../../../ui/Popup/imagePreviewModal";

interface Props {
  resetCMS: () => void;
}

const Banner = ({ resetCMS }: Props) => {
  const [faqPopup, setFaqPopup] = useState<{ show: boolean, faq: CMSTypes.Faq | null }>({ show: false, faq: null });
  const [faqLoading, setFAQLoading] = useState<boolean>(true);
  const [faqs, setFaqs] = useState<{ list: any, count: number }>({ list: [], count: 0 });
  const [pagination, setPagination] = useState<{ skip: number, limit: number }>({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [dialog, setDialog] = useState({ show: false, id: "",idWeb:'' });
  const { id } = useParams<{ id: string }>();
  const [cmsId, setCMSId] = useState<string>('');
  const [faqIndex, setFaqIndex] = useState<number>(0);
  const [error, setError] = useState<string>("");
  const [previewImage, setPreviewImage] = useState<{ show: boolean, url: string }>({ show: false, url: '' });

  const getFaqs = () => {
    const query = {
      page: (1 + pagination.skip),
      limit: pagination.limit,
      type: CMS_TYPE.INSTA,
      countryId: id,
    }
    listCountries({limit: 1000}).then(res => {
      // Filter country by id and store only the matching one
      const matchingCountry = res.data.countries.find((country: any) => country._id === id);
      console.log(matchingCountry,"matchingCountry");
      setFaqs({ 
        list: matchingCountry ? matchingCountry.bannerImageWeb : [], 
        count: matchingCountry ? 1 : 0 
      });
      setCMSId(matchingCountry?._id || '');
      setFAQLoading(false);
      
    }).catch(err => {
      setFAQLoading(false);
      setError(err.response.data.message);
    });
  };

  const deleteFAQ = () => {
    toast.promise(
      deleteBanner(id as string,dialog.id,dialog.idWeb),
      {
        pending: {
          render() {
            return "Deleting Banner...";
          },
        },
        success: {
          render() {
            getFaqs();
            setDialog({ show: false, id: "",idWeb:'' });
            return "Banner deleted successfully";
          },
        },
        error: {
          render({ data }: any) {
            return "Failed to delete Banner";
          },
        },
      });
  };

  useEffect(() => {
    setFAQLoading(true);
    getFaqs();
  }, [pagination.skip]);

  return (
    <div>
      <div className={styles.tabDtahd}>
        <h4>Banners</h4>
        <div>
          <button type="button" onClick={() => setFaqPopup({ show: true, faq: null })}>
            <img
              width={100}
              height={100}
              src={IMAGES.EditIcon}
              alt="defaultUser"
            />
            Create
          </button>
        </div>
      </div>

      <div className={commonStyles.tableData}>
          <div className={commonStyles.tableData}>
            <table>
              <thead>
                <tr>
                <th>Alt Text</th>
                  {LOCAL_CONSTANTS.instaTableHeaders?.map((header: any) => (
                    <th
                      className={`${["url", "createdAt"].includes(header?.value)
                        ? "cursor-pointer"
                        : ""
                        }`}
                      key={header?.value}
                    >
                      {header?.label}
                    </th>
                  ))}
                 
                </tr>
              </thead>
              <tbody>
                {faqLoading && (
                  <tr>
                    <td colSpan={7} align="center" className={styles.loadingText}>
                      {LOCAL_CONSTANTS.loading}
                    </td>
                  </tr>
                )}
                {!faqLoading && faqs?.list?.length === 0 && (
                  <tr>
                    <td colSpan={3} align="center">
                      No Banners Found
                    </td>
                  </tr>
                )}
                {error && (
                  <tr>
                    <td colSpan={7} align="center" className={styles.loadingText}>
                      {error}
                    </td>
                  </tr>
                )}
                {!faqLoading &&
                  faqs?.list?.map((item: any, index: number) => (
                    <tr key={index}>
                      <td>
                        {item.bannerImageAltText}
                      </td>
                        <td>
                          {item.bannerImage}
                        </td>
                      <td>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </td>
                      <td>
                        <Dropdown className="ps-0">
                          <div className="cursor-pointer">
                            <Dropdown.Toggle as={ActionButton}></Dropdown.Toggle>
                          </div>
                          <Dropdown.Menu as={DropDownMenu}>
                            <Dropdown.Item onClick={() => setPreviewImage({ show: true, url: item.bannerImage })}>
                              <FontAwesomeIcon
                                size="xs"
                                className="me-2"
                                icon={faEye}
                              />
                              View
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() =>{ setDialog({ show: true, id: item.bannerImage,idWeb:item._id }); setFaqIndex(index)}}>
                              <FontAwesomeIcon
                                size="xs"
                                className="me-2"
                                icon={faTrashAlt}
                              />
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {faqs.count > faqs?.list?.length &&
              <Pagination
                paginationState={pagination}
                setPaginationState={setPagination}
                count={faqs.count}
              />
            }
          </div>
        </div>

      <ImagePreviewModal 
        show={previewImage.show}
        handleClose={() => setPreviewImage({ show: false, url: '' })}
        imageUrl={previewImage.url}
      />

      <CreateUpdateBanner
        show={faqPopup.show}
        handleClose={() => setFaqPopup({ show: false, faq: null })}
        getFaqs={getFaqs}
        countryId={id || ''}
      />
      
      <Popup
        show={dialog.show}
        handleClose={() => setDialog({ show: false, id: "",idWeb:'' })}
        heading={LOCAL_CONSTANTS.areYouSure}
        content={"Are you sure you want to delete this Banner?"}
        handleSubmit={deleteFAQ}
        id={dialog.id}
      />
    </div>
  );
};

export default Banner;